import React from 'react';
import bggLogo from '../powered-by-bgg-rgb.svg';
import { useContext, useEffect, useState } from 'react';
import { GlobalStateContext } from '../GlobalState';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const { rowCount, researchRowCount, sellRowCount } = useContext(GlobalStateContext);
  const [rowCountLabel, setRowCountLabel] = useState('');

  // A effect that sets the value of a variable when the window.location.pathname changes
  useEffect(() => {
      // Get the current route to determine which row count to display
  const currentPath = location.pathname;
  let displayRowCount = 0;

  if (currentPath === '/research') {
    displayRowCount = researchRowCount;
    setRowCountLabel(`${displayRowCount === 20 ? 'Top ':''} ${displayRowCount} results`);
  } else if (currentPath === '/sell') {
    displayRowCount = sellRowCount;
    setRowCountLabel(`Rows: ${displayRowCount}`);
  } else if (currentPath === '/'){
    // Default to bgg-list row count for main route and trade route
    displayRowCount = rowCount;
    setRowCountLabel(`Rows: ${displayRowCount}`);
  } else {
    setRowCountLabel('');
  }
  }, [location.pathname, researchRowCount, sellRowCount, rowCount]);

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="row-count">
          {rowCountLabel}
        </div>
        <div className="footer-logo">
          <a href="https://boardgamegeek.com" target='_blank' rel="noreferrer">
            <img src={bggLogo} alt="Powered by BoardGameGeek" style={{ height: '30px' }} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
